<template>
  <section class="packages-list">
    <div
      v-if="!packagesList"
      class="packages-list__content"
    >
      <pacman-loader />
    </div>
    <div
      v-else-if="packagesList?.length > 0"
      class="packages-list__content"
    >
      <div
        class="packages-list__list"
        :class="`--${viewType}`"
      >
        <gf-package-card
          v-for="packageInfo in packagesList"
          :key="packageInfo.uuid"
          :package-info="packageInfo"
          :show-you-owner-label="showYouOwnerLabel"
          :show-company-agregation="showCompanyAgregation"
        />
      </div>
      <pagination
        v-if="page?.totalPages > 1"
        :pager="page"
        @change="paginate"
      />
    </div>
    <div
      v-else
      class="packages-list__content"
    >
      <div class="packages-list__empty">{{ emptyText }}</div>
    </div>
  </section>
</template>

<script>
import GfPackageCard from '@shared/shared-components/shared/GfPackageCard';
import Pagination from '@shared/shared-components/shared/pagination';
import PacmanLoader from '@shared/shared-components/shared/packman-loader';
import RegistryMessages from '@/shared-modules/modules/registry/registry.messages';

export default {
  name: 'PackagesList',
  components: {
    GfPackageCard,
    Pagination,
    PacmanLoader
  },
  props: {
    viewType: {
      type: String,
      default: null
    },
    packagesList: {
      type: Array,
      default: null
    },
    page: {
      type: Object,
      default: null
    },
    showYouOwnerLabel: {
      type: Boolean,
      default: true
    },
    showCompanyAgregation: {
      type: Boolean,
      default: true
    },
    emptyText: {
      type: String,
      default() {
        return this.$t('packages.none');
      }
    }
  },
  computed: {
    defaultEmptyText() {
      return this.$t('packages.none');
    }
  },
  methods: {
    paginate(page) {
      this.$router.push({ query: { ...this.$route.query, page: page - 1 } }).catch(() => {});
    }
  },
  i18n: {
    messages: RegistryMessages
  }
};
</script>

<style lang="scss">
$this: '.packages-list';

#{$this} {
  #{$this}__content {
    min-height: 130px;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 20px;

    #{$this}__list {
      display: grid;
      grid-template-columns: repeat(1fr, 1fr);
      gap: 16px;

      &.--columns {
        grid-template-columns: repeat(1fr, 1fr);

        @media screen and (min-width: 768px) {
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }

    #{$this}__empty {
      padding: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--light);
      border: 1px solid var(--border-color);
      border-radius: var(--border-radius);
    }
  }
}
</style>
